export enum AutomationQuestionTypeEnum {
  NOTIFICATION = 'notification',
  SINGLE_ANSWER = 'single_answer',
  MULTIPLE_ANSWERS = 'multiple_answers',
}
